import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class BalanceIcon extends AbstractIcon {
  static selector = "balance-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 64 64" xml:space="preserve">
        <path style="fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="M32,46V31c0,0,3.2,6,10.3,12.3c1.2,1,3,0.9,4-0.3l0,0c0.9-1.1,0.9-2.7,0-3.7C43.8,36.4,39,31,38,25.5
          C37.7,24,37,18,37,18h11c1.1,0,2-0.9,2-2v0c0-1.1-0.9-2-2-2h-6.2c-3.8,0-7.6-0.2-9.7-0.9c-2.7-1-5.1-3.1-5.1-6.1S29,2,32,2
          s5,2.2,5,4.9c0,2.8-2,6.1-9,6.1c-4.4,0-9.4-1.5-13-3.1c-1.1-0.5-2.4,0-3,1.1l0,0c-0.6,1.1-0.1,2.5,1,3.1c2.3,1.2,6.3,3,11,3.9l1,12
          c0,0,1.2,13.8,1.7,16.5c0.4,2.2,1.9,3.5,4.3,3.5"/>
          <circle style="fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" cx="31" cy="56" r="6"/>
      </svg>`
  }
}

componentsRegistryService.define(BalanceIcon);
